<it-card teaser="true" shadow="true" *ngIf="settings?.length">
  <div class="row">
    <div class="col">
      <it-alert color="primary"> 
        Da qui è possibile modificare il setting associato alla pratica. Premendo il tasto Conferma, la pratica verrà aggiornata con il nuovo setting selezionato.
      </it-alert>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col">
      <p class="example-section">
                <it-select
                  id="default-select"
                  label="Setting"
                  [(ngModel)]="selectedSetting"
                  defaultOption="Seleziona un elemento"
                  (ngModelChange)="onSelectedSetting($event)"
                >
                  <option [value]="null">Seleziona un elemento</option>
                  <option *ngFor="let setting of settings"
                  [value]="setting.code">
                    {{ setting.name }}
                  </option>
                </it-select>
              </p>

              <p class="example-section" *ngIf="selectedSetting && getSubsettings() && getSubsettings().length>1">
                <it-select
                  id="default-select"
                  label="Sub-setting"
                  [(ngModel)]="selectedSubsetting"
                  defaultOption="Seleziona un elemento"
                >
                  <option [value]="null">Seleziona un elemento</option>
                  <option
                    *ngFor="let subsetting of getSubsettings()"
                    [value]="subsetting.id"
                  >
                    {{ subsetting.name }}
                  </option>
                </it-select>
              </p>
    
      <div class="d-flex justify-content-end gap-2 mt-4">
        <button itButton="outline-primary" type="button" (click)="cancel()">
          Torna indietro
        </button>
        <button
          itButton="primary"
          type="button"
          [disabled]="!selectedSubsetting"
          (click)="confirm()"
        >
          Conferma cambio setting
        </button>
      </div>
    </div>
  </div>    
  </it-card>
  